import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import ProjectRoleListPageUI from './ProjectRoleListPageUI.js'

class ProjectRoleListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      projectList: null,
      filteredProjectList: null,
      searchFilter: ''
    }
  }

  render() {
    return (
      <ProjectRoleListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        projectList={this.state.projectList}
        filteredProjectList={this.state.filteredProjectList}
        // refresh, filter
        onRefreshClick={this.onRefreshClick}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        // join, leave
        onJoinClick={this.onJoinClick}
        onLeaveClick={this.onLeaveClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getProjects(context)
    this.getMessages(context)
  }

  getProjects(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/projects`,
      cacheKey: CacheKeys.Projects(context.session.accountId, context.session.userId),
      callback: this.getProjectsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectsCallback = (response) => {
    if (response.errorList.length > 0) {
      this.props.history.replace('/projects')
      return
    }
    let projectList = response.projectList
      .filter(project => project.status !== 'archived')
    projectList.forEach(project => project.submitted = false)
    this.setState({
      projectList: projectList,
    })
    this.applyFilters(projectList, this.state.searchFilter)
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Projects(context.session.accountId, context.session.userId))
    this.setState({
      errorList: null,
      projectList: null,
      filteredProjectList: null
    })
    this.getProjects(context)
  }

  onLeaveClick = (event) => {
    let projectId = event.target.getAttribute('data-row-id')
    console.log(projectId)
    let projectList = this.state.projectList
    let projectA = projectList.filter(project => project.projectId === projectId)
    if (projectA.length === 0 || projectA[0].submitted)
      return
    projectA[0].submitted = true
    this.setState({projectList: projectList})
    RestApiUtils.delete(this.props.context,
      `/api/user/projects/${projectId}`,
      this.onLeaveOrJoinCallback, {}
    )
  }

  onJoinClick = (event) => {
    let projectId = event.target.getAttribute('data-row-id')
    let projectList = this.state.projectList
    let projectA = projectList.filter(project => project.projectId === projectId)
    if (projectA.length === 0 || projectA[0].submitted)
      return
    projectA[0].submitted = true
    this.setState({projectList: projectList})
    RestApiUtils.post(this.props.context,
      `/api/user/projects/${projectId}`,
      this.onLeaveOrJoinCallback, {}
    )
  }

  onLeaveOrJoinCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      errorList: errorList,
      successMsg: response.success
    })

    if (errorList.length === 0) {
      let context = this.props.context
      let project = this.state.projectList.filter(project =>  project.projectId === response.projectUser.projectId)[0]
      project.submitted = false
      project.roleId = response.projectUser.roleId
      project.roleName = response.projectUser.roleName

      // for non admin users leaving project, remove deleted projectg
      let projectList = this.state.projectList
      if (!project.roleId && !this.props.context.permissions.includes('acc_manage')) {
        projectList = projectList.filter(project => project.projectId !== response.projectUser.projectId)
      }

      this.setState({
        projectList: projectList
      })
      CacheManager.removeObject(CacheKeys.Projects(context.session.accountId, context.session.userId));
      this.applyFilters(projectList, this.state.searchFilter)
    }
  }

  onSearchFilterChange = (event) => {
    console.log('here');
    let searchFilter = event.target.value
    this.setState({searchFilter: searchFilter})
    this.applyFilters(this.state.projectList, searchFilter)
  }

  applyFilters(projectList, searchFilter) {
    let filteredProjectList = projectList.filter(project => project.projectName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()))
    this.setState({filteredProjectList: filteredProjectList})
  }

  getMessages(context) {
    let arr = [
      'c_connected_projects',
      'c_leave',
      'c_join',
      'c_refresh',
      'c_no_projects'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_prj_role', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default ProjectRoleListPageSF
